<template>
  <unicom-modal-acao
    v-model="valueData"
    :larguraModal="600"
    textoTitulo="Deseja aprovar este arquivo?"
    :mensagem="mensagemAprovar"
    :textoBotaoConfirmar="textoBotaoConfirmarAprovar"
    tipoBotao="primario"
    :larguraBotaoConfirmar="184"
    @botao-confirmar="$emit('botao-confirmar')"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },

    possuiAlgumErroConsiderado: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      valueData: false
    };
  },

  computed: {
    mensagemAprovar() {
      return this.possuiAlgumErroConsiderado
        ? "Foram identificados erros de alta criticidade."
        : "Não foi identificado nenhum erro.";
    },

    textoBotaoConfirmarAprovar() {
      return this.possuiAlgumErroConsiderado ? "APROVAR COM ERRO" : "APROVAR";
    }
  },

  watch: {
    value() {
      this.valueData = this.value;
    },
    valueData() {
      this.$emit("input", this.valueData);
    }
  }
};
</script>
